/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useMemo, memo } from 'react';
import { Slide, Slider } from 'pure-react-carousel';
import { OverlayStyledImage, LeftChevronWrapper, RightChevronWrapper, CloseIconWrapper, StyledFigure, StyledFigcaption, BgPictureContainer, } from './styles';
import LeftChevron from '../icons/left-chevron';
import RightChevron from '../icons/right-chevron';
import CloseIcon from '../icons/close-icon';
import Modal from '../../components/modal/modal';
import { useCarousel } from './hooks/use-carousel';
import Typography from '../typograhy';
import { getImageUrl } from './get-image-url';
var customStyles = {
    content: {
        position: 'unset',
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        padding: 0,
        border: 'none',
        borderRadius: 'none',
        borderWidth: 0,
        backgroundColor: 'transparent',
        maxWidth: 'min(90%, 800px)',
    },
};
var OverlayCarousel = function (_a) {
    var images = _a.images, setOverlay = _a.setOverlay, setSelectedImage = _a.setSelectedImage, isOverlayOpen = _a.isOverlayOpen;
    var onSlideChange = useCallback(function (index) { return setSelectedImage(index); }, []);
    var _b = useCarousel(null, { onSlideChange: onSlideChange }), prev = _b.prev, next = _b.next;
    var handleKeyDown = useCallback(function (event) {
        if (!isOverlayOpen) {
            return;
        }
        switch (event.key) {
            case 'ArrowRight':
                next();
                break;
            case 'ArrowLeft':
                prev();
                break;
            default:
                break;
        }
    }, [isOverlayOpen, next, prev]);
    useEffect(function () {
        document.addEventListener('keydown', handleKeyDown);
        return function () { return document.removeEventListener('keydown', handleKeyDown); };
    }, [handleKeyDown]);
    var closeModal = useCallback(function () {
        setOverlay(false);
    }, [setOverlay]);
    var renderedImages = useMemo(function () {
        return images.map(function (image, index) {
            var smallImage = getImageUrl('small-mobile', image);
            var mediumImage = getImageUrl('medium-mobile', image);
            var largeImage = getImageUrl('large-mobile', image);
            var desktopImage = getImageUrl('desktop', image);
            var wideScreenImage = getImageUrl('wide-screen', image);
            return (React.createElement(StyledFigure, { key: "overlay_modal_image_" + index },
                React.createElement(BgPictureContainer, null,
                    !!wideScreenImage && React.createElement("source", { media: "(min-width:1024px)", srcSet: wideScreenImage }),
                    !!desktopImage && React.createElement("source", { media: "(min-width:640px)", srcSet: desktopImage }),
                    !!largeImage && React.createElement("source", { media: "(min-width:480px)", srcSet: largeImage }),
                    !!mediumImage && React.createElement("source", { media: "(min-width:320px)", srcSet: mediumImage }),
                    !!smallImage && (React.createElement(OverlayStyledImage, { loading: "lazy", alt: image === null || image === void 0 ? void 0 : image.caption, src: smallImage }))),
                React.createElement(StyledFigcaption, null,
                    React.createElement(Typography, { variant: "subtitle2", fontWeight: 'regular', color: "white" }, image === null || image === void 0 ? void 0 : image.caption))));
        });
    }, [images]);
    return (React.createElement(Modal, { isOpen: isOverlayOpen, onRequestClose: closeModal, style: customStyles, ariaHideApp: false },
        React.createElement(Slider, null, images.map(function (image, index) { return (React.createElement(Slide, { index: index, key: "slide_" + index }, renderedImages[index])); })),
        React.createElement(LeftChevronWrapper, { onClick: prev },
            React.createElement(LeftChevron, null)),
        React.createElement(RightChevronWrapper, { onClick: next },
            React.createElement(RightChevron, null)),
        React.createElement(CloseIconWrapper, { onClick: closeModal },
            React.createElement(CloseIcon, { width: 50, height: 50 }))));
};
export default memo(OverlayCarousel);
